export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function getBasePath() {
    return document.getElementsByTagName("base")[0].href;
}

export function getLanguage() {
    return document.getElementsByTagName("html")[0].lang;
}

export function dataSetToProps(dataset) {
    if ("props" in dataset) return JSON.parse(dataset.props);
    return Object.keys(dataset).reduce((acc, cur) => {
        let value = dataset[cur];
        acc[cur] = value.startsWith("{") || value.startsWith("[") ? JSON.parse(value) : value;
        return acc;
    }, {});
}

export function createEmptyArray(itemCount) {
    return new Array(Math.max(itemCount, 0)).fill(null);
}

export function insertAndExecute(id, text) {
    document.getElementById(id).innerHTML = text;
    var scripts = Array.prototype.slice.call(document.getElementById(id).getElementsByTagName("script"));
    for (var i = 0; i < scripts.length; i++) {
        if (!scripts[i].src && scripts[i].src !== "") {
            var tag = document.createElement("script");
            tag.src = scripts[i].src;
            document.getElementsByTagName("head")[0].appendChild(tag);
        }
        else {
            eval(scripts[i].innerHTML);
        }
    }
}